import React from "react";

import { Result, Button } from "antd";

import { Link } from "react-router-dom";

export function Status404() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Link to="/">
          <Button type="primary">Go Home</Button>
        </Link>
      }
    />
  );
}
